var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_3703_357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32031 6.89509C1.81963 5.77445 2.52551 4.79481 3.3531 3.90917C5.22668 1.90557 7.49761 0.622433 10.179 0.184649C13.9367 -0.428382 17.3004 0.476057 20.2068 3.03024C20.3903 3.19206 20.4357 3.28606 20.2357 3.48548C19.2101 4.51078 18.2003 5.55287 17.1846 6.58891C17.0806 6.695 17.0102 6.82526 16.8254 6.65203C14.2663 4.25899 10.0902 4.28652 7.3713 6.86689C6.45496 7.7403 5.75797 8.82592 5.33917 10.0321C5.27339 9.9898 5.2076 9.95219 5.14971 9.90519L1.32031 6.89509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30894 14.9189C5.67602 15.8697 6.13192 16.7687 6.80951 17.5322C8.53179 19.474 10.6703 20.3102 13.225 20.0407C14.4137 19.9145 15.4965 19.5035 16.5083 18.8724C16.6057 18.961 16.6978 19.0557 16.8004 19.1376C17.9846 20.0812 19.1687 21.0237 20.3528 21.9651C19.0682 23.2108 17.4872 24.0926 15.7663 24.5233C11.6757 25.5821 7.90287 24.9107 4.5524 22.2135C3.17512 21.1111 2.0655 19.6994 1.30981 18.0881L5.30894 14.9189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3555 21.9651C19.1713 21.0223 17.9872 20.0799 16.803 19.1376C16.7004 19.0557 16.6057 18.961 16.511 18.8724C17.3135 18.2473 17.9832 17.508 18.4227 16.5686C18.5904 16.1926 18.7292 15.8037 18.8378 15.4057C18.9181 15.1324 18.8937 15.0257 18.5622 15.029C16.5886 15.0458 14.615 15.0371 12.6414 15.0371C12.2237 15.0371 12.2237 15.0371 12.2237 14.5959C12.2237 13.2309 12.2296 11.8665 12.2178 10.5001C12.2178 10.2369 12.2605 10.1362 12.5513 10.1368C16.1915 10.1476 19.8303 10.1476 23.4678 10.1368C23.6652 10.1368 23.7875 10.1516 23.8217 10.3954C24.2744 13.6438 23.9119 16.7472 22.2429 19.6143C21.735 20.4966 21.1226 21.2976 20.3555 21.9651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30892 14.9189L1.3098 18.0881C0.659178 16.8527 0.283541 15.5259 0.10855 14.1434C-0.206205 11.7918 0.14964 9.39746 1.13349 7.24693C1.1881 7.12607 1.25783 7.0126 1.32033 6.8951L5.14972 9.90519C5.20959 9.9522 5.27603 9.9898 5.33918 10.0321C4.80434 11.6577 4.83132 13.2873 5.30892 14.9189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3703_357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.63de62ee852f1b16a8cd8d748dc3fc30.svg";
export { ForwardRef as ReactComponent };